module.exports = __webpack_public_path__ + "static/media/p_frv_map_tablet.d9489bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Pcg/p_frv_map_tablet.jpg
// module id = 544
// module chunks = 0